import { render } from "./5.vue?vue&type=template&id=6d3182fb&scoped=true"
import script from "./5.vue?vue&type=script&lang=js"
export * from "./5.vue?vue&type=script&lang=js"

import "./5.vue?vue&type=style&index=0&id=6d3182fb&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3182fb"]])

export default __exports__